var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bitcoin",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7931A",
    d: "M256,4c139.167,0,252,112.827,252,252c0,139.167-112.833,252-252,252C116.827,508,4,395.167,4,256 C4,116.827,116.827,4,256,4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M369.235,224.815c4.92-33.015-20.212-50.765-54.572-62.6l11.136-44.728l-27.225-6.783l-10.859,43.543 c-7.136-1.784-14.488-3.46-21.809-5.129l10.95-43.835L249.64,98.5l-11.159,44.712c-5.921-1.354-11.744-2.684-17.388-4.091 l0.03-0.139l-37.537-9.374l-7.245,29.077c0,0,20.196,4.629,19.773,4.914c11.028,2.753,13.02,10.051,12.681,15.834l-12.697,50.949 c0.762,0.193,1.746,0.477,2.83,0.908c-0.907-0.223-1.876-0.469-2.876-0.715l-17.803,71.382c-1.354,3.354-4.768,8.368-12.474,6.46 c0.27,0.4-19.788-4.937-19.788-4.937l-13.52,31.161l35.43,8.828c6.591,1.646,13.051,3.384,19.411,5.015l-11.267,45.235 l27.185,6.783l11.159-44.743c7.429,2,14.643,3.875,21.695,5.63l-11.112,44.543l27.224,6.768l11.26-45.144 c46.427,8.782,81.326,5.245,96.03-36.745c11.842-33.807-0.585-53.31-25.01-66.015C352.255,260.691,365.65,248.987,369.235,224.815 L369.235,224.815z M307.033,312.048c-8.428,33.807-65.345,15.535-83.794,10.951l14.95-59.938 C256.638,267.659,315.816,276.795,307.033,312.048z M315.447,224.331c-7.675,30.746-55.056,15.127-70.421,11.297l13.55-54.356 C273.95,185.102,323.431,192.254,315.447,224.331z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bitcoin_Cash",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4CCA47",
    d: "M130,37.762C250.523-31.822,404.652,9.473,474.239,130C543.822,250.522,502.523,404.655,382,474.238 C261.473,543.825,107.346,502.522,37.762,382C-31.824,261.473,9.473,107.349,130,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M338.473,172.376c-12.246-31.052-42.886-33.857-78.561-26.927l-12.72-44.303l-26.969,7.738l12.366,43.139 c-7.071,2.023-14.276,4.248-21.451,6.462l-12.434-43.438l-26.963,7.734l12.693,44.301c-5.805,1.789-11.513,3.547-17.104,5.151 l-0.043-0.135l-37.195,10.65l8.264,28.804c0,0,19.806-6.089,19.582-5.631c10.927-3.129,16.3,2.195,18.898,7.373l14.479,50.471 c0.756-0.214,1.75-0.459,2.904-0.629c-0.896,0.261-1.858,0.532-2.848,0.819l20.273,70.72c0.504,3.581,0.055,9.631-7.573,11.832 c0.434,0.212-19.604,5.618-19.604,5.618l3.872,33.746l35.097-10.069c6.531-1.87,12.994-3.595,19.318-5.363l12.86,44.809 l26.935-7.718l-12.707-44.328c7.434-1.983,14.618-3.966,21.603-5.972l12.647,44.131l26.961-7.75l-12.82-44.727 c44.598-15.607,73.053-36.12,64.792-79.837c-6.648-35.198-27.161-45.875-54.667-44.666 C341.705,211.936,347.454,195.102,338.473,172.376L338.473,172.376z M328.221,279.022c9.604,33.491-48.822,46.126-67.092,51.381 l-17.023-59.383C262.383,265.778,318.201,244.101,328.221,279.022z M291.648,198.851c8.727,30.464-40.115,40.628-55.338,44.994 l-15.442-53.849C236.097,185.625,282.524,167.08,291.648,198.851z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Etherium"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#627EEA",
    d: "M256,4c139.166,0,252,112.826,252,252c0,139.166-112.834,252-252,252C116.826,508,4,395.166,4,256 C4,116.826,116.826,4,256,4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillOpacity: 0.602,
    points: "254.844,63 254.844,202.704 372.923,255.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "254.844,63 136.75,255.461 254.844,202.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillOpacity: 0.602,
    points: "254.844,345.992 254.844,440.923 373,277.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "254.844,440.923 254.844,345.977 136.75,277.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillOpacity: 0.2,
    points: "254.844,324.028 372.923,255.461 254.844,202.735  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillOpacity: 0.602,
    points: "136.75,255.461 254.844,324.028 254.844,202.735  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ripple",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00AAE4",
    d: "M256,4c139.166,0,252,112.826,252,252c0,139.166-112.834,252-252,252C116.826,508,4,395.166,4,256 C4,116.826,116.826,4,256,4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M349.885,290.73c-10.874-6.43-23.117-8.291-35.253-8.736c-10.167-0.354-25.348-7.029-25.348-25.994 c0-14.127,11.182-25.494,25.363-26.001c12.136-0.438,24.363-2.299,35.237-8.729c26.979-15.965,38.883-49.473,28.239-79.473 c-10.675-30.008-40.821-47.834-71.506-42.29c-30.685,5.545-53.071,32.861-53.063,64.792c0,12.743,4.414,24.471,10.074,35.353 c4.737,9.151,7.137,26.132-9.144,35.768c-12.112,7.167-27.239,2.63-34.792-9.751c-6.375-10.467-14.081-20.264-24.863-26.64 c-26.993-15.965-61.27-9.774-81.303,14.681c-20.034,24.463-20.034,60.131,0,84.586c20.033,24.456,54.31,30.639,81.303,14.674 c10.782-6.367,18.48-16.165,24.855-26.609c5.237-8.598,18.319-19.533,34.799-9.781c12.097,7.167,15.85,22.855,9.144,35.775 c-5.66,10.89-10.074,22.609-10.074,35.346c0,31.93,22.379,59.246,53.063,64.783c30.685,5.553,60.831-12.273,71.506-42.281 C388.768,340.21,376.863,306.695,349.885,290.73z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M256,4c139.166,0,252,112.826,252,252c0,139.166-112.834,252-252,252C116.826,508,4,395.166,4,256 C4,116.826,116.826,4,256,4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.499,235.297H226.3l-15.597,46.511H88.603L104.499,235.297z M161.2,158.201c0,0,176.411,0,225.906,0 s35.392,50.103,35.392,50.103h-71.69H145.296L161.2,158.201z M96.4,358.898l16.196-50.096h205.204h72.598 c0,0-19.796,50.096-66.907,50.096C276.395,358.898,96.4,358.898,96.4,358.898z M350.808,208.304h71.69l-32.1,100.499H318.4 L350.808,208.304z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Litecoin",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CBC6C6",
    d: "M256,4c139.166,0,252,112.834,252,252S395.166,508,256,508C116.826,508,4,395.166,4,256S116.826,4,256,4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "168.222,306.618 145.75,315.34 156.586,271.889 179.326,262.768 212.103,130 292.883,130  268.966,227.576 291.16,218.594 280.455,261.906 257.984,270.889 244.626,325.768 366.25,325.768 352.5,382 149.718,382  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.1384f78280f26063b6c3c4df43b7478c.svg";
export { ForwardRef as ReactComponent };